/* eslint-disable */
export default {
  to: 'Vst.ot:',
  transferTo: 'Siirto kohteeseen',
  blindTransfer: 'Siirrä',
  warmTransfer: 'Kysy ensin',
  enterNameOrNumber: 'Anna numero',
  toVoicemail: 'Vastaajaan',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
